<template>
	<BaseCmsPage @load="onPageLoad">
		<CmsCheckoutWrapper>
			<WebshopCheckout>
				<ClientOnly>
					<BaseWebshopCart v-slot="{cart}" thumbPreset="cartPackage">
						<form @submit.prevent="onSubmit" v-if="cart">
							<div class="wc-form wc-form-review floating-labels-checkout">
								<div class="wc-form-col1">
									<WebshopHelloBar />
									<WebshopSteps :step="3" />

									<div v-if="cart" class="wc-payments">
										<div v-if="checkoutLoading || creation" class="wc-payments-loader"><span></span></div>
										<WebshopPaymentOptions v-for="item in cart.payments.available" :key="item.id" :cart="cart" :data="item" />
									</div>

									<WebshopPackage :review="true" />
								</div>

								<WebshopSidebar :meta="meta" review="true" mode="total_full" />
								<WebshopWidgetFixedbar review="true" :meta="meta" mode="total_full" />
							</div>
						</form>
					</BaseWebshopCart>
					<template #fallback>
						<BaseThemeUiLoading />
					</template>
				</ClientOnly>
			</WebshopCheckout>
		</CmsCheckoutWrapper>
	</BaseCmsPage>
</template>

<script setup>
	import {useForm, useValidateField} from 'vee-validate';
	const {meta} = useForm();

	const apiRoutes = useApiRoutes();
	const auth = useAuth();
	const webshop = useWebshop();
	const endpoints = useEndpoints();
	const cartData = computed(() => webshop.getCartData());
	const gtm = useGtmBB();
	const { creation, updateCreationState, orderSuccess, orderData, orderSubmit, leanpayData, paymentError, paymentgateway, creditCard, checkoutLoading, newPayment, formValid } = useCheckout();

	newPayment.value = null;

	// redirect to cart page if there are errors in cart
	if (cartData.value?.cart?.errors?.cart?.length) {
		setTimeout(async () => {
			await navigateTo(apiRoutes.getAppUrl('webshop_shopping_cart'));
		}, 1000);
	}

	// redirect to cart page if there are warnings in cart
	if (cartData.value?.cart?.warnings?.cart?.length) {
		setTimeout(async () => {
			await navigateTo(apiRoutes.getAppUrl('webshop_shopping_cart'));
		}, 1000);
	}

	//payment options selected
	const paymentOptionSelected = computed(() => {
		let selectedPayments = (cartData.value?.cart != null) ? cartData.value?.cart?.payments?.selected : null;
		let selectedOptions = (selectedPayments != null) ? selectedPayments[0].options : null;
		let selectedOption = null;
		let selectedOptionProduct = false;
		if(selectedOptions != null) {
			selectedOption = selectedOptions.find(el => el.selected == true);
			selectedOptionProduct = (selectedOption && selectedOption.enabled_when_remove_products != null) ? true : false;
		}

		return (selectedOptions == null || (selectedOption != null && selectedOptionProduct == false)) ? 1 : 0;
	})

	function onPageLoad(data) {
		if(!data) return;
		gtm.pageView({
			url: data?.url || '',
			title: data?.title || '',
		});
	}

	onMounted(async () => {
		formValid.value = (paymentOptionSelected.value) ? 1 : 0;
	});

	//bankart script
	function bankartScript() {
		let s = document.createElement("script")
		function setAttributes(el, attrs) {
			for(var key in attrs) {
				el.setAttribute(key, attrs[key])
			}
		}
		setAttributes(s, {"data-main": "payment-js", "src": paymentgateway.value.script_url})
		document.head.appendChild(s)
	}

	// handle form submit
	async function onSubmit() {
		checkoutLoading.value = true;
		orderSubmit.value = 1;
		creation.value = true;
		localStorage.setItem('creation', JSON.stringify(creation.value));
		updateCreationState(true);

		// Send order type request for payment on delivery
		const selectedPayment = webshop.getCartData()?.cart?.payments?.selected?.[0].code || null;
		if(selectedPayment == 'pouzece') {
			await useApi(endpoints.get('_post_hapi_webshop_order_type'), {
				method: 'POST',
				body: {order_type: 'confirmed_order'}
			});
		}

		await useApi(`${endpoints.get('_get_hapi_webshop_cart_full')}`).then(async (res) => {
			const cartDataValue = (res?.data) ? res.data : null;
			if(!cartDataValue?.cart) return console.error('Cart data not availbale');

			const selectedPayments = cartDataValue?.cart?.payments?.selected;
			if(selectedPayments?.length) {
				const paymentOptionsGtm = selectedPayments.map(payment => {
					return payment.title ? payment.title : payment.code
				}).join(', ');
				gtm.addPaymentInfo({
					'paymentOption': paymentOptionsGtm
				})
			}

			await useApi(`${endpoints.get('_post_hapi_webshop_order')}`, {
				method: 'POST',
				body: {'success': true, 'data': cartDataValue}
			}).then(async (res) => {
				if(res.success) {
					await webshop.fetchCart();
					creation.value = false;
					localStorage.setItem('creation', JSON.stringify(creation.value));
					updateCreationState(false);

					const id_code = res.data?.id_code ? res.data.id_code : null;
					if(!id_code) return console.error('Order identificator not availbale');

					const webshopOrderId = endpoints.get('_get_hapi_webshop_order');
					const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", id_code);

					await useApi(webshopOrder, {method: 'GET'})
					.then(async (res) => {
						orderData.value = res.data
						if(res.data?.cart?.payment_type == null) {
							orderSuccess.value = 1;
							await navigateTo({
								path: apiRoutes.getAppUrl('webshop_thank_you'),
								query: {order_identificator: id_code}
							});

							checkoutLoading.value = false;
							orderSubmit.value = 0;
						} else if(res.data?.cart?.payment_type == 'redirect') {
							const createPaymentId = endpoints.get('_get_hapi_webshop_create_payment');
							const createPayment = createPaymentId.replace("%ID%-%CODE%", id_code);

							await useApi(createPayment, {method: 'GET'})
							.then(async (res) => {
								if(res.success) {
									const link = res.data.redirect_url
									const hiddenForm = (res.data.hidden_form) ? res.data.hidden_form : null
									if(hiddenForm != null) {
										leanpayData.value = res.data;
										await navigateTo(apiRoutes.getAppUrl('webshop_payment_form_autosubmit'));
										checkoutLoading.value = false;
									} else {
										window.location.href = link;
									}
									orderSubmit.value = 0;
								} else if (res.data.label_name === 'error_empty_payment_form') {
									paymentError.value = res.data;
									await navigateTo({
										path: apiRoutes.getAppUrl('webshop_payment_new'),
										query: {order_identificator: id_code}
									});
									checkoutLoading.value = 0;
								}
							});
						} else if(res.data?.cart?.payment_type == 'credit_cart_form') {
							orderSuccess.value = 1;
							await navigateTo({
								path: apiRoutes.getAppUrl('webshop_payment_create'),
								query: {order_identificator: id_code}
							});

							const paymentgatewayId = endpoints.get('_get_hapi_webshop_order_specific_paymentgateway_data');
							const paymentgatewayData = paymentgatewayId.replace("%ID%-%CODE%", id_code);
							await useApi(paymentgatewayData, {method: 'GET'})
							.then(async (res) => {
								paymentgateway.value = res.data;
								let pgMode = paymentgateway.value.pg_mode;
								let pgModeFillFields = 'phone_email';
								if(pgMode == 'cc') {
									pgModeFillFields = 'cc_first_name,cc_last_name';
								}
								let apiExtraValue = '?type=webshop.' + pgMode + '&order_identificator=' + id_code + '&fill_fields=' + pgModeFillFields + '&change_fields=cc_number:ignore_validation=1,cc_number:type=hidden,cc_cvv:ignore_validation=1,cc_cvv:type=hidden,cc_expire_month:ignore_validation=1,cc_expire_month:type=hidden,cc_expire_year:ignore_validation=1,cc_expire_year:type=hidden';
								await useApi(`${endpoints.get('_get_hapi_customer_fields')}${apiExtraValue}`, {
									method: 'GET'
								}).then(res => creditCard.value = res.data)

								if(res.success && paymentgateway.value && paymentgateway.value.pg_mode == 'cc') {
									bankartScript()
								}
							})

							orderSubmit.value = 0
						}
					});
				} else {
					await webshop.fetchCart();
					creation.value = false;
					localStorage.setItem('creation', JSON.stringify(creation.value));
					updateCreationState(false);

					orderSuccess.value = 1;
					await navigateTo(apiRoutes.getAppUrl('webshop_failed_order'));

					checkoutLoading.value = false;
					orderSubmit.value = 0;
				}
			});
		});
	};
</script>

<style lang="less" scoped>
	.wc-payments{
		display: flex; flex-direction: column; width: 100%; margin-bottom: 40px; position: relative;

		@media (max-width: @m){margin-bottom: 30px;}
	}
	.wc-payments-loader{
		display: flex; align-items: center; justify-content: center; background: rgba(255, 255, 255, 0.3); position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 11;
		//span{width: 60px; height: 60px; background: url(assets/images/loader.svg) no-repeat center; background-size: 60px; z-index: 11;}
	}
</style>
